var $ = require('jquery');
var Storage = require('../common/storage');

function OrtsFilter() {
	return {
		value: '',
		wildcard: 1,
		mandator: 'current',
		maxPerPage: 10,
		page: 1,
		search: '&',
		sortname: 'name',
		sortorder: 'ASC',
	}
}

function OrtsListe() {

	var storageKey = 'verwaltung.orte.filter';

	var controls = {
		value: $('input[name=value]'),
		wildcard: $('input[name=wildcard]'),
		mandator: $('input[name=mandator]:radio'),
		maxresults: $('select[name=maxPerPage]'),
		reset: $('#resetFilter')
	};

	var selectors = {
		container: '#orte_container',
		indicator: '#progress-location-list'
	};

	var filter = getOrCreateFilter();

	function newFilter() {
		return new OrtsFilter();
	}

	function getOrCreateFilter() {
		var filter = Storage.getPreferred().getItem(storageKey);
		if (!filter) {
			filter = newFilter();
		}
		return filter;
	}

	function saveFilterAndLoad() {
		saveFilter();
		load();
	}

	function saveFilter() {
		Storage.getPreferred().setItem(storageKey, filter);
	}

	function applyFilter() {
		controls.value.val(filter.value);
		if (filter.wildcard > 0) {
			controls.wildcard.prop('checked', true);
		}
		else {
			controls.wildcard.prop('checked', false);
		}
		controls.mandator.prop('checked', false);
		controls.mandator.filter('[value=' + filter.mandator + ']').prop('checked', true);
		controls.maxresults.val(filter.maxPerPage).trigger('chosen:updated');
	}

	function load() {
		if (filter.value && filter.value.length > 0) {
			filter.search = filter.value.replace(/\*/g, '%');
			if (controls.wildcard.filter(':checked').val() > 0) {
				filter.search = '%' + filter.search + '%';
			}
		}
		else {
			filter.search = '%';
		}
		$(selectors.indicator).removeClass('hidden');
		$.get(
			'ajax_orte',
			{filter: JSON.stringify(filter)},
			function (data) {
				$(selectors.indicator).addClass('hidden');
				$(selectors.container).html(data);
			},
			'html'
		);
	}

	controls.value.change(function () {
		filter.value = $(this).val();
		saveFilterAndLoad();
	});
	controls.wildcard.click(function () {
		filter.wildcard = $(this).filter(':checked').val();
		saveFilterAndLoad();
	});
	controls.mandator.click(function () {
		filter.mandator = $(this).filter(':checked').val();
		saveFilterAndLoad();
	});
	controls.maxresults.change(function () {
		filter.maxPerPage = $(this).val();
		saveFilterAndLoad();
	});
	controls.reset.click(function (e) {
		filter = newFilter();
		applyFilter();
		saveFilterAndLoad();
		e.preventDefault();
		return false;
	});

	applyFilter();
	load();

	return {
		go: function (page) {
			filter.page = page;
			saveFilterAndLoad();
		},

		next: function () {
			filter.page++;
			saveFilterAndLoad();
		},

		previous: function () {
			filter.page--;
			saveFilterAndLoad();
		},

		sort: function (field) {
			if (filter.sortname == field) {
				this.switchSortOrder();
			}
			filter.sortname = field;
			saveFilterAndLoad();
		},

		switchSortOrder: function () {
			if (filter.sortorder == 'ASC') {
				filter.sortorder = 'DESC';
			}
			else {
				filter.sortorder = 'ASC';
			}
		}
	}
}

module.exports = OrtsListe;
